var factsheetHeader = {
	label: {
		highLowBar: "Intraday range",
		lastPriceDateTime: "Date/Time",
		volume: "Volume",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Number of Constituents",
		country: "Country",
		symbol: "Symbol",
		fundIssuer: "Issuer",
		fundCategory: "Category",
		pea: "PEA",
		pme: "PEA-PME",
		srd: "SRD",
		tradingStatus: "Trading Status",
		perf1Year: "Perf. 1 Year",
		perf5Years: "Perf. 5 Years",
		perf1Week: "Perf. 1 Week",
		perf1Month: "Perf. 1 Month",
		suspended: "Suspended",
		marketStatus: "Market Status",
		tradingPhase: "Trading Phase",
		expectedDividends: "Expected Dividends",
		expectedPriceEarningsRatio: "Expected P/E Ratio"
	},
	"true": "Yes",
	"false": "No",
	open: "Open",
	close: "Close"
};
var en = {
	factsheetHeader: factsheetHeader
};

export { en as default, factsheetHeader };
